import { useCallback, useRef, useEffect } from "react";

const useInfinityScroll = ({ isLoading, updatePage, hasMore }) => {
  const observer = useRef(null);
  const loadingRef = useRef(false); // ✅ avoid double-trigger
  const updatePageRef = useRef(updatePage); // ✅ use stable reference

  // Keep updatePage ref in sync
  useEffect(() => {
    updatePageRef.current = updatePage;
  }, [updatePage]);

  const lastElementRef = useCallback(
    (node) => {
      if (isLoading || !hasMore) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !loadingRef.current) {
          loadingRef.current = true;
          updatePageRef.current().finally(() => {
            loadingRef.current = false;
          });
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore]
  );

  return lastElementRef;
};

export default useInfinityScroll;
